document.addEventListener('DOMContentLoaded', function () {
    const buttons = document.querySelectorAll('.quick-add__submit');
    buttons.forEach((button) => {
      button.addEventListener('click', function() {
        const id = button.parentNode.dataset.modal;
  
        const section = document.querySelector(id);
        if (!section) return;
  
        // Verifica a cada 500ms se o modal está aberto
        const checkModal = setInterval(() => {
          if (document.querySelector(id).hasAttribute('open')) {
            if(section.querySelector('.flavours')) {
              newVariantPicker(section);
            }
            clearInterval(checkModal); // Para a verificação após executar a função
          }
        }, 500);
      })
    });
    
    function newVariantPicker(section) {
      // Inputs de quantidade de pacotes
      const qty_inputs = section.querySelectorAll('.qty_input');
      // Inputs de quantidade de cada Sabor
      const flavour_qty_inputs = section.querySelectorAll('.flavours__wrapper .quantity__input');
      // Botão de comprar
      const buy_button = section.querySelectorAll('.product-form__submit')[0];
      // Botão de aumentar quantidade de cada Sabor
      const flavour_qty_plus = section.querySelectorAll('.quantity__plus');
      // Botão de diminuir quantidade de cada Sabor
      const flavour_qty_minus = section.querySelectorAll('.quantity__minus');
      // Inputs para enviar quantidades de variantes para carrinho
      const variants_quantity = section.querySelectorAll('.variant-quantity');
      // Container de cada input de sabor
      const flavour_wrapper = section.querySelectorAll('.flavour-input_wrapper');
  
      // Preços a serem substituídos
      const old_price = section.querySelector('#regular-price');
      const old_sale_price = section.querySelector('#sale-price');
      const old_pix_price = section.querySelector('#pix-price');
      const pix_discount = old_pix_price.dataset.pixDiscount;
      
      // Quantidades de pacotes
      let quantities = [];
      qty_inputs.forEach((item) => {
        quantities.push(parseInt(item.value));
      })
  
      // Descontos de quantidade de pacotes
      const descontos = section.querySelector('.flavours').dataset.descontos.split(',');
  
      function formatMoney(value) {
        return value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace(/\u00A0/g, '');
      }
  
      function pricesAndButton(quantity) {    
        // Quantidade de sabores escolhidos
        let quantity_put = 0;
        let totalPrice = quantity * parseInt(flavour_qty_inputs[0].dataset.price)/100;
        flavour_qty_inputs.forEach((item) => {
          quantity_put = quantity_put + parseInt(item.value);
        });
        
        const index = quantities.indexOf(parseInt(quantity));
        let desconto = 1 - parseInt(descontos[index])/100;
        if(!desconto) desconto = 1;

        // Substitui preço sem desconto de quantidade de pacotes, esconde caso não tenha desconto e mostra caso tenha desconto
        if(desconto == 1){
          old_sale_price.parentElement.classList.add('visually-hidden'  );
          old_sale_price.textContent = '';            
        } else {
          old_sale_price.textContent = formatMoney(totalPrice);
          old_sale_price.parentElement.classList.remove('visually-hidden');          
        }
  
        // Substitui preço com desconto
        old_price.textContent = formatMoney(totalPrice * desconto);
        old_pix_price.textContent = formatMoney(totalPrice * desconto * pix_discount);
        
        // Ativar ou desativar botão de acordo com a quantidades
        buy_button.disabled = quantity_put != quantity;
        changeDisabled(quantity_put >= quantity);

        changeMinusDisabled();
      } 
      
      // Iteração entre todos os inputs de quantidade de pacotes
      qty_inputs.forEach((item) => {
        item.addEventListener('click', function() {
          var quantity = this.value;
          pricesAndButton(quantity);
        })
      })
  
      // Função para reforçar mínimo e máximo de quantidade
      function enforceMinMax(el) {
        if (el.value != "") {
          if (parseInt(el.value) < parseInt(el.min)) {
            el.value = el.min;
          }
          if (parseInt(el.value) > parseInt(el.max)) {
            el.value = el.max;
          }
        }
      }
  
      flavour_qty_inputs.forEach((item, i) => {
        item.addEventListener('change', function() {
          enforceMinMax(this);
  
          flavour_wrapper[i].classList.toggle('not-chosen', this.value == 0);
          variants_quantity[i].value = this.value;
  
          const quantity = section.querySelector('.qty_input:checked').value;
          pricesAndButton(quantity);
        })
      })
  
      function changeDisabled(disabled) {
        flavour_qty_plus.forEach((item, i) => {
          if (flavour_wrapper[i].classList.contains('unavailable')) {  
            item.disabled = true;
            item.classList.add('disabled');
            return;
          }
          item.disabled = disabled;
          item.classList.toggle('disabled', disabled);
        });
      }

      function changeMinusDisabled() {
        flavour_qty_minus.forEach((item, i) => {
          if(flavour_qty_inputs[i].value <= 0) {
            item.disabled = true;
            item.classList.add('disabled');
          } else {
            item.disabled = false;
            item.classList.remove('disabled');
          }
        });
      }
      
      changeDisabled(false);
      /*
      // Setando variantes pré-selecionadas
      let j = 0;
      let count = 0;

      while (count < quantities[0]) {
        // Se o wrapper não tiver a classe 'unavailable', clica e incrementa a contagem
        if (!flavour_wrapper[j].classList.contains('unavailable')) {
          flavour_qty_plus[j].click();
          count++; // Aumenta a contagem de cliques bem-sucedidos
        }

        // Avança para o próximo wrapper
        j++;

        // Se chegou ao final da lista, volta para o início
        if (j >= flavour_wrapper.length) {
          j = 0;
        }
      }
      */
      const quantity = section.querySelector('.qty_input:checked').value;
      pricesAndButton(quantity);

      initModeToggle(section, pricesAndButton, formatMoney);
    }

    function initModeToggle(section, pricesAndButton, formatMoney) {
      const toggle = section.querySelector('.purchase-mode-toggle');
      if (!toggle) return;

      const wrapper = section.querySelector('.flavours__wrapper');
      const handleUnica = wrapper.dataset.handle;
      const handleAssinatura = toggle.dataset.handleAssinatura;
      const skusUnica = toggle.dataset.skusUnica.split(',');
      const skusAssinatura = toggle.dataset.skusAssinatura.split(',');

      async function fetchBySku(handle) {
        const res = await fetch(`/products/${handle}.js`);
        if (!res.ok) throw new Error(`Produto não encontrado: ${handle}`);
        const data = await res.json();
        const map = {};
        data.variants.forEach(v => {
          map[v.sku] = {
            id: v.id,
            price: v.price,
            available: v.available,
            inventory_quantity: v.inventory_quantity
          };
        });
        return map;
      }

      // Inicia o fetch imediatamente para ter os dados prontos quando o usuário clicar
      const dataPromise = Promise.all([
        fetchBySku(handleUnica),
        fetchBySku(handleAssinatura)
      ]).catch(e => {
        console.error('[Purchase Toggle] Erro ao buscar dados dos produtos:', e);
        return null;
      });

      function applyMode(mode, variantsMap) {
        const { skus, variants, handle } = variantsMap[mode];
        const flavourInputs = section.querySelectorAll('.flavours__wrapper .quantity__input');
        const quantityInputEls = section.querySelectorAll('.flavours__wrapper quantity-input');
        const flavourWrappers = section.querySelectorAll('.flavour-input_wrapper');
        const variantQtyInputs = section.querySelectorAll('.variant-quantity');

        flavourInputs.forEach((input, i) => {
          const sku = skus[i];
          const variant = variants[sku];
          if (!variant) return;

          quantityInputEls[i].dataset.url = `/products/${handle}?variant=${variant.id}`;

          input.dataset.price = variant.price;
          const maxQty = variant.available
            ? (variant.inventory_quantity > 0 ? variant.inventory_quantity : 999)
            : 0;
          input.dataset.max = maxQty;
          input.max = maxQty;
          input.value = 0;
          input.dataset.cartQuantity = 0;

          const idInput = section.querySelector(`.product-variant-id-${i}`);
          if (idInput) {
            idInput.value = variant.id;
            idInput.disabled = !variant.available;
          }

          if (variantQtyInputs[i]) {
            variantQtyInputs[i].value = 0;
            variantQtyInputs[i].disabled = !variant.available;
          }

          if (!variant.available || maxQty === 0) {
            flavourWrappers[i].classList.add('unavailable');
          } else {
            flavourWrappers[i].classList.remove('unavailable');
          }
          flavourWrappers[i].classList.add('not-chosen');
        });

        // Adiciona/remove tag "FRETE GRÁTIS" nas opções sem tag
        section.querySelectorAll('.tag-discount--js').forEach(el => el.remove());
        if (mode === 'assinatura') {
          section.querySelectorAll('.quantity-selector label.variant-info').forEach(label => {
            if (!label.querySelector('.tag-discount')) {
              const tag = document.createElement('span');
              tag.className = 'tag-discount tag-discount--js';
              tag.textContent = 'FRETE GRÁTIS';
              label.prepend(tag);
            }
          });
        }

        // Atualiza preços no seletor de quantidade
        const basePrice = variants[skus[0]].price;
        const qtyLabels = section.querySelectorAll('.quantity-selector label.variant-info');
        const qtyInputsAll = section.querySelectorAll('.qty_input');
        qtyLabels.forEach((label, i) => {
          const qty = parseInt(qtyInputsAll[i].value);
          const desconto = parseInt(label.dataset.desconto) || 0;
          const units = parseInt(label.dataset.units);

          const priceTotal = basePrice * qty;
          const discountTotal = desconto > 0 ? Math.round(priceTotal * (100 - desconto) / 100) : priceTotal;
          const priceUnit = discountTotal / units;
          const economize = priceTotal - discountTotal;

          const priceEl = label.querySelector('.variant-price');
          if (priceEl) {
            const textNode = Array.from(priceEl.childNodes).find(n => n.nodeType === Node.TEXT_NODE);
            if (textNode) textNode.textContent = formatMoney(priceUnit / 100);
          }

          const economizeEl = label.querySelector('.economize');
          if (economizeEl) economizeEl.textContent = 'Economize ' + formatMoney(economize / 100);
        });

        const url = new URL(window.location.href);
        url.searchParams.set('modo', mode);
        history.pushState({}, '', url);

        const checkedQty = section.querySelector('.qty_input:checked');
        if (checkedQty) pricesAndButton(checkedQty.value);
      }

      const btns = toggle.querySelectorAll('.purchase-mode-toggle__btn');

      // Registra os cliques imediatamente — sem depender do fetch
      btns.forEach(btn => {
        btn.addEventListener('click', async () => {
          if (btn.classList.contains('active')) return;
          const mode = btn.dataset.mode;
          btns.forEach(b => b.classList.toggle('active', b === btn));

          const result = await dataPromise;
          if (!result) return;
          const [unicaVariants, assinaturaVariants] = result;
          applyMode(mode, {
            unica: { skus: skusUnica, variants: unicaVariants, handle: handleUnica },
            assinatura: { skus: skusAssinatura, variants: assinaturaVariants, handle: handleAssinatura }
          });
        });
      });

      // Aplica modo inicial vindo da URL
      const initialMode = new URLSearchParams(window.location.search).get('modo') || 'assinatura';
      if (initialMode === 'assinatura') {
        dataPromise.then(result => {
          if (!result) return;
          const [unicaVariants, assinaturaVariants] = result;
          btns.forEach(b => b.classList.toggle('active', b.dataset.mode === 'assinatura'));
          applyMode('assinatura', {
            unica: { skus: skusUnica, variants: unicaVariants, handle: handleUnica },
            assinatura: { skus: skusAssinatura, variants: assinaturaVariants, handle: handleAssinatura }
          });
        });
      }
    }

    const product_infos = document.querySelectorAll('product-info:has(.variants-wrapper)');
    product_infos.forEach((section) => {
      newVariantPicker(section);
    })

    // Toggle Assinatura / Compra Única para o picker padrão (variant-selects)
    // Usa event delegation + re-query do DOM para sobreviver a re-renders do tema
    function initStandardModeToggle() {
      const toggle = document.querySelector('[data-pm-toggle-standard]');
      if (!toggle) return;
      if (document._pmStandardToggleReady) return;
      document._pmStandardToggleReady = true;

      const handleAssinatura = toggle.dataset.handleAssinatura;
      const skusUnica      = toggle.dataset.skusUnica.split(',');
      const skusAssinatura = toggle.dataset.skusAssinatura.split(',');
      const dosesCount     = [15, 60];

      // Fetch assinatura — único fetch necessário
      const dataPromise = fetch(`/products/${handleAssinatura}.js`)
        .then(r => { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(data => {
          const map = {};
          data.variants.forEach(v => {
            map[v.sku] = { id: v.id, price: v.price, compare_at_price: v.compare_at_price };
          });
          return map;
        })
        .catch(e => { console.error('[PM Toggle Standard]', e); return null; });

      // Taxa pix calculada uma vez no load (ratio estável para o produto)
      let pixRate = null;
      {
        const vs  = document.querySelector('variant-selects[data-section]');
        const sec = vs ? document.getElementById(`shopify-section-${vs.dataset.section}`) : null;
        const sp  = sec?.querySelector('.price-item--sale')?.textContent || '';
        const pp  = sec?.querySelector('.pix-price')?.textContent || '';
        const s = parseFloat(sp.replace(/[^\d,]/g, '').replace(',', '.'));
        const p = parseFloat(pp.replace(/[^\d,]/g, '').replace(',', '.'));
        if (s && p) pixRate = p / s;
      }

      // Snapshot das doses unica (capturado sempre antes de sobrescrever)
      let origDoses = null;

      // Modo armazenado em variável JS — não depende da URL
      // (o tema usa history.replaceState('?variant=xxx') que apagaria ?modo= da URL)
      document._pmCurrentMode = document._pmCurrentMode ||
        new URLSearchParams(window.location.search).get('modo') || 'assinatura';

      // Cache síncrono das variantes — necessário para o interceptor de submit
      let cachedAssVariants = null;
      dataPromise.then(v => { cachedAssVariants = v; });

      // Intercepta o submit do formulário na fase de captura (antes do handler do tema)
      // Garante o ID correto independente de qualquer re-render AJAX
      document.addEventListener('submit', (e) => {
        const variantInput = e.target?.querySelector('input[name="id"]');
        if (!variantInput) return;
        if (getCurrentMode() !== 'assinatura') return;
        if (!cachedAssVariants) return;
        const unicaSku = getVariantData().sku;
        const idx      = skusUnica.indexOf(unicaSku);
        const assSku   = idx !== -1 ? skusAssinatura[idx] : null;
        const assV     = assSku ? cachedAssVariants[assSku] : null;
        if (assV?.id) variantInput.value = assV.id;
      }, true);

      function money(cents) {
        return (cents / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }
      function getCurrentMode() {
        return document._pmCurrentMode;
      }
      function setCurrentMode(mode) {
        document._pmCurrentMode = mode;
        const url = new URL(window.location.href);
        url.searchParams.set('modo', mode);
        history.pushState({}, '', url);
      }

      // Re-queries frescos a cada chamada (sobrevivem a re-renders)
      function getSec() {
        const vs = document.querySelector('variant-selects[data-section]');
        return vs ? document.getElementById(`shopify-section-${vs.dataset.section}`) : null;
      }
      function getVariantIdInput() {
        const vs = document.querySelector('variant-selects[data-section]');
        if (!vs) return null;
        return document.querySelector(`#product-form-${vs.dataset.section} input[name="id"]`);
      }
      function getVariantData() {
        const vs = document.querySelector('variant-selects[data-section]');
        try { return JSON.parse(vs?.querySelector('script[data-selected-variant]')?.textContent || '{}'); }
        catch(e) { return {}; }
      }
      function setButtons(mode) {
        document.querySelectorAll('[data-pm-toggle-standard] .purchase-mode-toggle__btn').forEach(b => {
          b.classList.toggle('active', b.dataset.mode === mode);
        });
      }
      function writePrice(v) {
        const sec = getSec();
        if (!v?.price || !sec) return;
        const ps = `R$${money(v.price)}`;
        const saleEl    = sec.querySelector('.price-item--sale');
        const regularEl = sec.querySelector('.price__regular .price-item--regular');
        const compareEl = sec.querySelector('.price__sale .price-item--regular');
        const pixEl     = sec.querySelector('.pix-price');
        if (saleEl)    saleEl.textContent    = ps;
        if (regularEl) regularEl.textContent = ps;
        if (compareEl && v.compare_at_price) compareEl.textContent = `R$${money(v.compare_at_price)}`;
        if (pixEl && pixRate) pixEl.textContent = `R$${money(Math.round(v.price * pixRate))} no pix`;
      }

      function enterAssinatura(assVariants) {
        const sec  = getSec();
        const input = getVariantIdInput();
        const unicaSku = getVariantData().sku;
        const idx    = skusUnica.indexOf(unicaSku);
        const assSku = idx !== -1 ? skusAssinatura[idx] : null;
        const assV   = assSku ? assVariants[assSku] : null;

        if (input && assV?.id) input.value = assV.id;
        writePrice(assV);

        // Snapshot das doses unica antes de sobrescrever
        const doseEls = [...(sec?.querySelectorAll('.dose-price') || [])];
        origDoses = doseEls.map(el => el.innerHTML);

        doseEls.forEach((el, i) => {
          const v = assVariants[skusAssinatura[i]];
          if (!v) return;
          const dp = (v.price / dosesCount[i] / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          el.innerHTML = `R$${dp}<small>/dose</small>`;
        });

        sec?.querySelectorAll('.product-form__input--pill label').forEach(label => {
          label.querySelector('.tag:not(.tag-frete-js)')?.style.setProperty('display', 'none');
          if (!label.querySelector('.tag-frete-js')) {
            const tag = document.createElement('span');
            tag.className = 'tag tag-frete-js';
            tag.textContent = 'Frete grátis';
            label.prepend(tag);
          }
        });

        setButtons('assinatura');
        setCurrentMode('assinatura');
      }

      function enterUnica() {
        const sec   = getSec();
        const input = getVariantIdInput();
        const v     = getVariantData();

        if (input && v.id) input.value = v.id;
        writePrice(v);

        const doseEls = [...(sec?.querySelectorAll('.dose-price') || [])];
        if (origDoses) doseEls.forEach((el, i) => { if (origDoses[i]) el.innerHTML = origDoses[i]; });

        sec?.querySelectorAll('.product-form__input--pill label').forEach(label => {
          label.querySelectorAll('.tag-frete-js').forEach(t => t.remove());
          label.querySelector('.tag')?.style.removeProperty('display');
        });

        setButtons('unica');
        setCurrentMode('unica');
      }

      // MutationObserver no bloco de preço: reaplica preço assinatura após AJAX do tema
      {
        const vs = document.querySelector('variant-selects[data-section]');
        const priceEl = vs ? document.getElementById(`price-${vs.dataset.section}`) : null;
        if (priceEl) {
          let priceTimer;
          new MutationObserver(() => {
            if (getCurrentMode() !== 'assinatura') return;
            clearTimeout(priceTimer);
            priceTimer = setTimeout(async () => {
              const assVariants = await dataPromise;
              if (!assVariants) return;
              const unicaSku = getVariantData().sku;
              const idx      = skusUnica.indexOf(unicaSku);
              const assSku   = idx !== -1 ? skusAssinatura[idx] : null;
              const assV     = assSku ? assVariants[assSku] : null;
              writePrice(assV);
            }, 30);
          }).observe(priceEl, { childList: true, subtree: true });
        }
      }

      // MutationObserver nas labels das variantes: reaplica tag "Frete grátis" sempre que
      // o tema re-renderizar os labels (ex: atualização de disponibilidade via AJAX)
      {
        const vs = document.querySelector('variant-selects[data-section]');
        if (vs) {
          let freteTimer;
          let applyingFrete = false;
          new MutationObserver(() => {
            if (applyingFrete || getCurrentMode() !== 'assinatura') return;
            clearTimeout(freteTimer);
            freteTimer = setTimeout(() => {
              applyingFrete = true;
              const sec = getSec();
              sec?.querySelectorAll('.product-form__input--pill label').forEach(label => {
                label.querySelector('.tag:not(.tag-frete-js)')?.style.setProperty('display', 'none');
                if (!label.querySelector('.tag-frete-js')) {
                  const tag = document.createElement('span');
                  tag.className = 'tag tag-frete-js';
                  tag.textContent = 'Frete grátis';
                  label.prepend(tag);
                }
              });
              applyingFrete = false;
            }, 30);
          }).observe(vs, { childList: true, subtree: true });
        }
      }

      // Event delegation — sobrevive a re-renders do DOM
      document.addEventListener('click', async e => {
        const btn = e.target.closest('[data-pm-toggle-standard] .purchase-mode-toggle__btn');
        if (!btn) return;
        const target  = btn.dataset.mode;
        const current = getCurrentMode();
        if (target === current) return;
        if (target === 'assinatura') {
          const assVariants = await dataPromise;
          if (!assVariants) return;
          enterAssinatura(assVariants);
          // Segundo sinal: reaplica após 300ms para cobrir qualquer re-render AJAX do tema
          setTimeout(() => {
            if (getCurrentMode() !== 'assinatura') return;
            enterAssinatura(assVariants);
          }, 300);
        } else {
          enterUnica();
          setTimeout(() => {
            if (getCurrentMode() !== 'unica') return;
            enterUnica();
          }, 300);
        }
      });

      // Variant:change — aplica assinatura imediatamente (sem delay)
      // document._pmCurrentMode não é afetado pelo history.replaceState do tema
      document.addEventListener('variant:change', async () => {
        if (getCurrentMode() !== 'assinatura') return;
        const assVariants = await dataPromise;
        if (!assVariants) return;
        enterAssinatura(assVariants);
        // Segundo sinal: garante preços, doses e tag frete grátis após re-render AJAX do tema
        setTimeout(() => {
          if (getCurrentMode() !== 'assinatura') return;
          enterAssinatura(assVariants);
        }, 300);
      });

      // Modo inicial da URL
      if (document._pmCurrentMode === 'assinatura') {
        dataPromise.then(assVariants => {
          if (!assVariants) return;
          enterAssinatura(assVariants);
        });
      }
    }

    initStandardModeToggle();
  })